import React from 'react'
import SectionContainer from '../../../Homepage/SectionContainer'
import { Col, Row } from 'reactstrap'
import DynamicInlineForm from '../../../component/DynamicInline/DynamicInlineForm'
const MainForm = ({ params, }) => {
  if (params === "visa-migration") return (
    <SectionContainer mainId="Innerpage" >
      <Row style={{ marginTop: "0rem" }}>
        <Col>
          <h1 className="font-heading">
            Reserve Your One-to-One Visa & Migration Session
          </h1>
          <p className="country-paragraph-text mt-3 mb-4">
            Tell us a bit about yourself and choose a convenient date and time, our team will be ready to assist you with your visa extension, migration pathways, or documentation support
          </p>
        </Col>
      </Row>

      <DynamicInlineForm
        fullName={true}
        email={true}
        phone={true}
        serviceId={true}

        preferedBranchId={true}
        appointment={true}
        isAppointment={true}
        slots={true}
        buttondesc="BOOK YOUR SESSION"

        message={true}
        formOrigin={4}
      />

    </SectionContainer>

  )

  if (params === "oshc") return (
    <SectionContainer mainId="careerpage" >
      <Row style={{ marginTop: "0rem" }}>
        <Col>
          <h1 className="font-heading">
            Reserve Your One-to-One Health Insurance Support Session
          </h1>
          <p className="country-paragraph-text mt-3 mb-4">
            Fill in your details and book a time that works for you, we’ll help you compare, renew, or update
            your OSHC/OVHC to match your visa and lifestyle needs.
          </p>
        </Col>
      </Row>

      <DynamicInlineForm
        fullName={true}
        email={true}
        phone={true}
        serviceId={true}
        formOrigin={4}
        preferedBranchId={true}
        appointment={true}
        isAppointment={true}
        slots={true}
        buttondesc="BOOK YOUR SESSION"

        message={true}
      />

    </SectionContainer>
  )

  if (params === "education") return (
    <SectionContainer mainId="careerpage" >
      <Row style={{ marginTop: "0rem" }}>
        <Col>
          <h1 className="font-heading">
            Reserve Your One-to-One Education Support Session
          </h1>
          <p className="country-paragraph-text mt-3 mb-4">
           Share your details and select a suitable date and time, and our team will guide you with admissions, enrolments, and academic planning.
          </p>
        </Col>
      </Row>

      <DynamicInlineForm
        fullName={true}
        email={true}
        phone={true}
        serviceId={true}
        formOrigin={4}
        preferedBranchId={true}
        appointment={true}
        isAppointment={true}
        slots={true}
        buttondesc="BOOK YOUR SESSION"

        message={true}
      />

    </SectionContainer>
  )

  if (params === "tax-return") return (
    <SectionContainer mainId="ielts-prep-subpage" >
      <Row style={{ marginTop: "0rem" }}>
        <Col>
          <h1 className="font-heading">
            Reserve Your One-to-One Tax Return Assistance Session
          </h1>
          <p className="country-paragraph-text mt-3 mb-4">
            Provide your details and choose a convenient date and time, our team will guide you through
            accurate tax filing, compliance, and essential financial obligations.
          </p>
        </Col>
      </Row>

      <DynamicInlineForm
        fullName={true}
        email={true}
        phone={true}
        serviceId={true}
        formOrigin={4}
        preferedBranchId={true}
        appointment={true}
        isAppointment={true}
        slots={true}
        buttondesc="BOOK YOUR SESSION"

        message={true}
      />

    </SectionContainer>
  )
  return null
}

export default MainForm